import React, { useEffect, useState } from 'react';
import { complianceTypeLabel } from './complianceIssuePresenters';

function formatScanDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

function scanTypeLabel(scan) {
  if (scan.path_type === 'conflict') {
    return scan.conflict_mode === 'dvd'
      ? 'Document conflict'
      : 'Requirement conflict';
  }
  if (scan.path_type === 'compliance_check') return 'Compliance check';
  if (scan.path_type === 'gap') return 'Gap';
  return scan.path_type || 'Scan';
}

export default function ScanFilterModal({
  isOpen,
  projectId,
  activeScanId,
  onClose,
  onSelectScan,
  fetchScans,
}) {
  const [scans, setScans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen || !projectId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchScans(projectId)
      .then((list) => {
        if (!cancelled) setScans(list || []);
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || 'Failed to load scans');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [isOpen, projectId, fetchScans]);

  if (!isOpen) return null;

  return (
    <div className="scan-filter-modal__backdrop" onClick={onClose}>
      <div className="scan-filter-modal__card" onClick={(e) => e.stopPropagation()}>
        <div className="scan-filter-modal__header">
          <h3>Filter by scan</h3>
          <button
            type="button"
            className="scan-filter-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="scan-filter-modal__body">
          {loading ? (
            <div className="scan-filter-modal__state">Loading scans…</div>
          ) : error ? (
            <div className="scan-filter-modal__state scan-filter-modal__state--error">
              {error}
            </div>
          ) : scans.length === 0 ? (
            <div className="scan-filter-modal__state">No scans yet.</div>
          ) : (
            <ul className="scan-filter-modal__list">
              {scans.map((scan) => {
                const isActive = scan.scanId === activeScanId;
                return (
                  <li key={scan.scanId}>
                    <button
                      type="button"
                      className={[
                        'scan-filter-modal__row',
                        isActive ? 'scan-filter-modal__row--active' : '',
                      ].filter(Boolean).join(' ')}
                      onClick={() => onSelectScan(scan.scanId)}
                    >
                      <div className="scan-filter-modal__row-main">
                        <span className="scan-filter-modal__type">
                          {scanTypeLabel(scan)}
                          {scan.compliance_type
                            ? ` · ${complianceTypeLabel(scan.compliance_type)}`
                            : ''}
                        </span>
                        <span className="scan-filter-modal__date">
                          {formatScanDate(scan.created_at)}
                        </span>
                      </div>
                      <div className="scan-filter-modal__row-meta">
                        <span className="scan-filter-modal__count">
                          {scan.issue_count} issue{scan.issue_count === 1 ? '' : 's'}
                        </span>
                        <span
                          className={`scan-filter-modal__status scan-filter-modal__status--${scan.status}`}
                        >
                          {scan.status}
                        </span>
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}